export const checkStatusReverse = (products) => {
	return products.reduce((acc, product) => {
		if (acc + (product.quantity - product.reverse_quantity) === 0) {
			return false;
		}
		return true;
	}, false);
};
